let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fW1As")).then(() => parcelRequire('ghDtB'));